/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type DefaultAnswerLocalizationType = keyof typeof defaultAnswerLocalizationMap;

const defaultAnswerLocalizationMap = {
    ar: 'لم يتم العثور على إجابة',
    hy: 'Ոչ մի պատասխան չգտնվեց',
    bn: 'No answer found',
    eu: 'No answer found',
    bg: 'Не е намерен Отговор',
    ca: "No s'ha trobat cap resposta",
    'zh-hans': '未找到答案',
    'zh-hant': '未找到答案',
    hr: 'Odgovor nije pronađen',
    cs: 'Nebyla nalezena žádná odpověď',
    da: 'Intet svar fundet',
    nl: 'Geen antwoord gevonden',
    en: 'No answer found',
    et: 'Vastust ei leitud',
    fi: 'Vastausta ei löytynyt',
    fr: 'Aucune réponse trouvée',
    gl: 'No answer found',
    de: 'Keine Antwort gefunden',
    el: 'Δεν βρέθηκε απάντηση',
    gu: 'કોઈ જવાબ મળ્યો નથી',
    he: 'לא נמצאה תשובה',
    hi: 'कोई उत्तर नहीं मिला',
    hu: 'Nem található válasz',
    is: 'Ekkert svar fannst',
    id: 'Tidak ada jawaban yang ditemukan',
    ga: 'Níor aimsíodh freagra ar bith',
    it: 'Nessuna risposta trovata',
    ja: '答えが見つかりません',
    kn: 'ಯಾವುದೇ ಉತ್ತರ ಸಿಗಲಿಲ್ಲ',
    ko: '답을 찾을 수 없음',
    lv: 'Atbilde nav atrasta',
    lt: 'Atsakymo nerasta',
    ml: 'ഉത്തരം ലഭ്യമല്ല',
    ms: 'Tiada Jawapan ditemui',
    nb: 'Finner ikke noe svar',
    pl: 'Nie znaleziono odpowiedzi',
    pt: 'Nenhuma resposta encontrada',
    pa: 'ਕੋਈ ਜਵਾਬ ਨਹੀਂ ਲੱਭਿਆ',
    ro: 'Nu s-a găsit niciun răspuns',
    ru: 'Ответ не найден',
    'sr-cryl': 'Није пронађен одговор',
    'sr-latn': 'Nije pronađen odgovor',
    sk: 'Nenašla sa žiadna odpoveď',
    sl: 'Odgovor ni bil najden',
    es: 'No se ha encontrado respuesta',
    sv: 'Inget svar hittades',
    ta: 'எந்த பதிலும் கிடைக்கவில்லை',
    te: 'సమాధానం కనుగొనబడలేదు',
    th: 'ไม่พบคําตอบ',
    tr: 'Yanıt bulunamadı',
    uk: 'Відповіді не знайдено',
    ur: 'کوئی جواب نہیں ملا',
    vi: 'Không tìm thấy câu trả lời'
};

export const getLanguageDefaultAnswer = (code: DefaultAnswerLocalizationType) =>
    defaultAnswerLocalizationMap[code] ?? defaultAnswerLocalizationMap.en;
